import type { TodoItem } from '@terra/shared-dto-chat-types';

export type TodoQueue = {
  remaining: TodoItem[];
  done: TodoItem[];
};

export function splitTodoQueue(todos: TodoItem[]): TodoQueue {
  return {
    remaining: todos.filter(
      (todo) => todo.state === 'pending' || todo.state === 'in_progress',
    ),
    done: todos.filter(
      (todo) => todo.state === 'completed' || todo.state === 'cancelled',
    ),
  };
}
